// lib/filters/parseTransportType

function parseString() {
    return function (transport, dateOutShow) {
        const typeName = ['жд вагон','авто', 'судно',''];
        let type = 3
        if (!dateOutShow){
            if (transport.match(/^[0-9]+$/) != null) type = 0
        } else type = 3
        return `${transport} <br /> ${typeName[type]}`
    }

}


export default {
    filters: {parseTransportType: parseString()}
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseTransportType.js
 **/